import React from 'react';

const Component = props => {
	return (
		<>
			<div className='pt-[5px]'>
				<h2 className='text-[36px] text-[#282e3f] mb-[25px]'>Droit pénal</h2>
			</div>
			<div className='mt-[30px]'>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet GAVA-<i>Lex</i> vous conseillera et vous défendra dans tous les dossiers de droit pénal
					(audition à la police, tribunal de police, tribunal correctionnel, etc..).
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Si vous êtes soupçonné d'avoir commis une <strong>infraction</strong>, vous serez convoqué à la
					police afin d'être entendu sur les faits qui vous sont reprochés. A cette occasion, le cabinet
					pourra vous assister afin de vérifier que vos droits sont bien respectés.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet peut également vous assister au cours d'une <strong>audition</strong> lorsque vous êtes
					entendu en qualité de victime.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Si un dossier est à l'information (<strong>Procureur du Roi</strong>) ou à l'instruction (
					<strong>Juge d'instruction</strong>), le cabinet vous aidera au cours de cette procédure
					(consultation du dossier, demande de devoirs complémentaires, etc…).
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet vous conseillera et vous défendra si vous êtes poursuivi par le Procureur du Roi devant
					le <strong>tribunal de police</strong>, le <strong>tribunal correctionnel</strong> ou la{' '}
					<strong>Cour d'assises</strong>.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Si vous êtes <strong>victime</strong> d'une infraction et que vous souhaitez vous constituer{' '}
					<strong>partie civile</strong>, le cabinet vous accompagnera tout au long de la procédure, quelque
					soient les faits que vous reprochez à la partie adverse (toute infraction : contravention, crime,
					délit).
				</p>
				<div className='organigation-text w-[64%] col:float-none col:w-full mt-[30px]'>
					<h2 className='text-[24px] text-[#282e3f] mb-[8px] block'>Aperçu des Cas Pratiques : </h2>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Audition à la police
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Dossier à l'instruction ou à l'information
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Défense devant le tribunal correctionnel
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Constitution de partie civile
					</span>
				</div>
			</div>
		</>
	);
};

export default Component;
